import {Component, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FileInput, FileInputComponent, FileValidator} from "ngx-material-file-input";
import {ReplaySubject} from "rxjs";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {Dictionary} from "../../../../shared/interface/dictionary";
import {AddressImport} from "../../../../shared/interface/address-import";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FormHelperService} from "../../../../shared/services/form-helper.service";
import {AddressImportService} from "../../../../shared/services/address-import.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {DOCUMENT} from "@angular/common";
import {delay, first, takeUntil} from "rxjs/operators";
import {Uuid} from "../../../../shared/interface/response/uuid";
import {HttpErrorResponse} from "@angular/common/http";
import {permissionTagDialogData} from "../add-permission-tag-user/add-permission-tag-user.component";
import {UserService} from "../../../../shared/services/user.service";

export interface permissionTagUserDialogData {
  permissionTag: number;
}

@Component({
  selector: 'app-permission-tags-user-import',
  templateUrl: './permission-tags-user-import.component.html',
  styleUrls: ['./permission-tags-user-import.component.scss']
})
export class PermissionTagsUserImportComponent implements OnInit, OnDestroy {

  @ViewChild('fileInput') fileInputComponent: FileInputComponent;

  userImportFormValid = false;
  userImportForm: FormGroup;
  fileControl: FormControl;
  permissionTagControl: FormControl;

  typeKeys: string[] = [];
  fileMaxSize = 52428800;
  processingRequest = false;
  formErrors = {};

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor (
    private fb: FormBuilder,
    private snack: MatSnackBar,
    private formHelper: FormHelperService,
    private addressImportService: AddressImportService,
    public dialogRef: MatDialogRef<PermissionTagsUserImportComponent>,
    private userService: UserService,
    @Inject(DOCUMENT) private document: Document,
    @Inject(MAT_DIALOG_DATA) public data: permissionTagDialogData
  ) {
    this.userImportForm = fb.group({
      permissionTag: this.permissionTagControl = fb.control('', [Validators.required]),
      fileContent: fb.control('', [Validators.required]),
      fileName: fb.control('', [Validators.required]),
      file: this.fileControl = fb.control('', [Validators.required, FileValidator.maxContentSize(this.fileMaxSize)]),
    });
    this.permissionTagControl.setValue(data.permissionTag);
    }

  ngOnInit(): void {
    this.userImportForm.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        delay(0)
      )
      .subscribe(() => {
        this.userImportFormValid = this.userImportForm.valid;
      });

    this.fileControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe((file: FileInput) => {
        if (!file || file.files.length === 0) {
          this.userImportForm.get('fileContent').setValue('');
          this.userImportForm.get('fileName').setValue('');
          return;
        }

        file.files.forEach((fileToRead: File) => {
          const reader = new FileReader();
          reader.readAsDataURL(fileToRead);
          reader.onload = () => {
            this.userImportForm.get('fileName').setValue(fileToRead.name);
            this.userImportForm.get('fileContent').setValue(/base64,(.+)/.exec(reader.result.toString())[1]);
          };
        });
      });
  }


  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  import(): void {
    if (!this.userImportForm.valid) {
      this.userImportForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }

    this.processingRequest = true;
    this.formHelper.removeBackendErrorState(this.userImportForm, this.formErrors);
    this.formErrors = {};


    this.userService.importPermissionTag(this.userImportForm.value)
      .subscribe(() => {
        this.snack.open('Pomyślnie zaimportowano użytkowników', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.dialogRef.close();
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        if (error.status.toString() !== '200' ) {
          this.snack.open('Podczas importowania użytkowników wystąpił błąd', error.status.toString(), {
            duration: 2000,
          });
        }else {
          this.snack.open('Pomyślnie zaimportowano użytkowników', '', {
            duration: 2000,
          });
          this.processingRequest = false;
          this.dialogRef.close();
        }

      })
    ;
  }

  resetFileValue(): void {
    this.fileControl.setValue('');
    this.fileInputComponent.clear();
  }

  cancel(e): void {
    this.dialogRef.close(e);
    return;
  }

  closeDialog(e): void {
    this.dialogRef.close(e);
  }
}
